import { observable, action, runInAction } from 'mobx'
import uuid from 'uuid/v4'
import { message } from 'antd'
import { json } from '../../../../utils/ajax'
import {setStore} from "../../../../utils/Utils";

class MaintainContentStore {

    //constructor***************************************************************************************************** */
    @observable directory
    @observable contents
    @observable catalogSelectId
    @observable loading
    @observable options
    @observable carseries
    @observable carSysId
    @observable rowData

    constructor () {
        this.options = []
        this.directory = []
        this.contents = []
        this.carseries = []
        this.catalogSelectId = ''
        this.carSysId=''
        this.loading = false
        this.rowData = {id: ''}
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    //Tree
    @action
    initDirectory = async (value) => {
        runInAction(() => {
            this.contents = []
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog/list?carseriesId=${value}`)
        if (res.length === 0) {
            message.warning('该车系没有目录！')
            runInAction(() => {
                this.directory = [];
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.directory = res
            this.loading = false
        })
    }

    //ShowContent
    @action loadContents = async (directoryId) => {
            this.loading = true
        if (directoryId.level !== 4) {
            runInAction(() => {
                this.loading = false
                this.contents = []
            })
            return
        }
        const result = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog/selectLevel?id=` + directoryId.id);

        if(result.data ===  parseInt(`${process.env.REACT_APP_CATALOG_URL}`)||result.data === parseInt(`${process.env.REACT_APP_CATALOG2_URL}`)){
            const contents = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/content/searchOne?id=${directoryId.id}`)
            if (contents.status && contents.status === 0) {
                return
            }
            runInAction(() => {
                this.catalogSelectId = directoryId.id
                this.contents = contents.length ? contents : [{
                        id: `${uuid()}`,
                        image: ' ',
                        defaultContent: '',
                        type: 1,
                        catalogId: this.catalogSelectId
                    }]
                this.loading = false
            })
        } else {
            runInAction(() => {
                this.loading = false
                this.contents = []
            })
        }
    }

    //Save
    @action saveContents = async () => {
        if(this.contents.length === 0){
            message.warning('请选择内容！')
            return
        }
        runInAction(() => {
            this.loading = true
        })
        for (let i = 0; i < this.contents.length; i++) {
            let content = this.contents[i]
            if (!content.defaultContent.trim() && !content.image.trim()) {
                message.error('请填写完内容后保存！')
                runInAction(() => {
                    this.loading = false
                })
                return
            }
        }
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/content/save`, this.contents)
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog/updateApprovalState/${this.catalogSelectId}/1`)

        message.success('保存成功！')
        runInAction(() => {
            this.loading = false
        })
    }

    //送审
    @action submit = async () => {
        if (this.contents.length > 0) {
            //查询审批状态
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog:approvalState/${this.catalogSelectId}`)
            if (res === 1 || res === 4) {
                const data = {
                    'approvalOption': 0,
                    'catalogId': this.catalogSelectId
                }
                await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/approval`, data)
                await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog/updateApprovalState/${this.catalogSelectId}/2`)
                message.success('送审成功')
            } else if (res === 2) {
                message.error('内容待审中，请勿再次送审')
            } else if (res === 3) {
                message.error('内容审批已通过，请勿再次送审')
            }
        } else {
            message.error('请保存内容后再送审')
        }
    }

    @action changeContentTitle = (id, value) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (id === item.id) {
                    return {...item, title: value}
                }
                return item
            })
        })
    }

    @action addContent = (id, type) => {
        const contents = []
        this.contents.forEach(item => {
            contents.push(item)
            if (item.id === id) {
                contents.push({
                    id: `${uuid()}`,
                    image: '',
                    defaultContent: '',
                    type: type * 1,
                    catalogId: this.catalogSelectId
                })
            }
        })
        runInAction(() => {
            this.contents = contents
        })
    }

    @action setContent = (id, value) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === id) {
                    return {...item, defaultContent: value}
                }
                return item
            })
        })
    }

    @action delContent = (id) => {
        const contents = this.contents.filter(item => item.id !== id)
        runInAction(() => {
            this.contents = contents.length > 0 ? contents : [{
                    id: `${uuid()}`,
                    image: '',
                    defaultContent: '',
                    type: 1,
                    catalogId: this.catalogSelectId
                }]
        })
    }

    @action delImage = (contentId, imageIndex) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === contentId) {
                    return {...item, image: item.image.trim().split(',').filter((img, index) => index !== imageIndex).join(',')}
                }
                return item
            })

        })

    }

    @action addImage = (id, url) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === id) {
                    return {...item, image: item.image.trim().length > 0 ? `${item.image},${url}` : url}
                }
                return item
            })
        })
    }

    @action contentUp = (id) => {
        const index = this.contents.findIndex(item => item.id === id)
        if (index > 0) {
            runInAction(() => {
                this.contents = this.swapItems(this.contents, index, index - 1)
            })
        }
    }

    @action contentDown = (id) => {
        const index = this.contents.findIndex(item => item.id === id)
        if(index+1 === this.contents.length){
            return
        }
        if (index >= 0 && index < this.contents.length) {
            runInAction(() => {
                this.contents = this.swapItems(this.contents, index, index + 1)
            })
        }
    }

    swapItems = (arr, index1, index2) => {
        arr[index1] = arr.splice(index2, 1, arr[index1])[0]
        return arr
    }

    @action emptySelect = () => {
        runInAction(() => {
                this.brands = {
                    list: [],
                    selected: ''
                }
                this.carSeries = {
                    list: [],
                    selected: ''
                }
            }
        )
    }
    @action empetyDirectory = () => {
        runInAction(() => {
                this.directory = []
            }
        )

    }
    @action empetyContents = () => {
        runInAction(() => {
                this.contents = []
            }
        )
    }

    /**
     * 初始化车系
     */
    @action initCarseries = async() => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/carseriesCatalogs`)
        if(res && res.status === 0){
            return
        }
        runInAction(() => {
            this.carseries = res
            this.loading = false
        })
    }

    /**
     * 取车系ID
     */
    @action getCarSysId = (value) =>{
        runInAction(()=>{
            this.carSysId = value;
        })
    }
}

export default new MaintainContentStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/maintain/Content/store.js